import React from "react";
import i18n from "i18n/i18n";
import { isChunkLoadError, reloadOnceForChunkError } from "helpers/chunkReload";
import "./ChunkErrorBoundary.scss";

interface Props {
  children: React.ReactNode;
}

interface State {
  failed: boolean;
  isChunkError: boolean;
}

class ChunkErrorBoundary extends React.Component<Props, State> {
  state: State = { failed: false, isChunkError: false };

  static getDerivedStateFromError(error: unknown): State {
    return { failed: true, isChunkError: isChunkLoadError(error) };
  }

  componentDidCatch(error: unknown): void {
    if (isChunkLoadError(error) && reloadOnceForChunkError()) return;
    console.error("Unhandled error caught by ChunkErrorBoundary:", error);
  }

  handleReload = (): void => {
    window.location.reload();
  };

  render(): React.ReactNode {
    if (!this.state.failed) return this.props.children;

    return (
      <div className="chunk-error-boundary" role="alert">
        <h2 className="chunk-error-boundary__title">
          {this.state.isChunkError
            ? i18n.t("app_updated_reload_required")
            : i18n.t("something_went_wrong")}
        </h2>
        <button
          type="button"
          className="btn btn-primary chunk-error-boundary__action"
          onClick={this.handleReload}
        >
          {i18n.t("reload_page")}
        </button>
      </div>
    );
  }
}

export default ChunkErrorBoundary;
